// extracted by mini-css-extract-plugin
export default {"container":"RZ-z","heading":"SZ-z","links":"TZ-z","copy":"UZ-z","subCopy":"VZ-z","linksLeft":"WZ-z","linksCenter":"XZ-z","linksRight":"YZ-z","link":"ZZ-z","onlyLink":"_Z-z"};